import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchEvents } from 'src/api/event';
import { FETCH_EVENTS, requestEvents, requestEventsFailure, requestEventsSuccess } from './actions';

/* Events */
function* fetchEventsSaga(action: AnyAction): SagaIterator {
    yield put(requestEvents());

    const { error, response } = yield call(fetchEvents, action.pageable);

    if (error) yield put(requestEventsFailure(error));
    else yield put(requestEventsSuccess(response));
}

export function* generateFetchEventsWatcher() {
    yield takeLatest(FETCH_EVENTS, fetchEventsSaga);
}
